/**
* Modals plugin declaration
* @desc Adds support for modals within the app
**/

import ModalManager from './ModalManager.vue';
import module from './module'; // Vuex modals module

export default {
  install (Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }

    // Register modals vuex module 
    options.store.registerModule('modals', module);

    // Register modals component
    Vue.component('ModalManager', ModalManager);

    // Within the Vue community, it is generally expected that plugins which 
    // modify the Vue prototype prefix any added properties with a dollar sign ($).
    // this is referred to as an instance method

    // Adding $modals to Vue.prototype allows us to use $modals within Vue as this.$modals()
    Vue.prototype.$modal = {
      /*
      Usage example: 

      import ModalClassic from '@/plugins/modals/ModalClassic.vue'

      const ModalExample = {
        name: 'ModalExample',
        functional: true,

        render: (h, { data }) => {
          data.props = {
            foo: this.foo
          }

          return h(ModalClassic, data);
        }
      };

      this.$modal.add(ModalExample);
      */

      /**
      * Add
      * @desc Adds a modal
      * @param {object} component - A Vue functional component
      **/
      add: (component) => {
        options.store.dispatch('addModal', component);
      },

      /**
      * Remove
      * @desc Removes a modal
      * @param {object} [name] - Provide an optional name parameter to remove a specific modal, otherwise the most recent modal will be removed 
      **/
      remove: (name) => {
        options.store.dispatch('removeModal', name);
      },

      /**
      * Remove All
      * @desc Removes all modals
      **/
      removeAll: () => {
        options.store.commit('modals/REMOVE_ALL_MODALS');
      }
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/plugins/modals/index.js